var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"recruit-qa"},[_c('div',{staticClass:"wrap"},[_vm._m(0),_c('div',{staticClass:"block-cover"},_vm._l((_vm.qaBoxList),function(qaBoxListData){return _c('UiQaQaBox',{key:qaBoxListData.id,staticClass:"item",attrs:{"qestion":qaBoxListData.qestion,"answer":qaBoxListData.answer}})}),1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"black-bar"},[_c('h3',[_vm._v("よくある質問")])])
}]

export { render, staticRenderFns }